import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { StandardizedValidators } from 'src/app/helpers/StandardizedValidators';
import { eQuestionStatus } from '../../../../models/eQuestionStatus';
import { QuestionFilterFields } from '../../classes/QuestionFilterFields';

@Component({
	selector: 'app-questions-filter-form',
	templateUrl: './questions-filter-form.component.html',
	styleUrls: ['./questions-filter-form.component.scss']
})
export class QuestionsFilterFormComponent {

	fg : FormGroup;
	eQuestionStatus = eQuestionStatus;
	@Output() eeFiltersChange = new EventEmitter<QuestionFilterFields>();
	emitTimeoutRef! : NodeJS.Timeout;

	constructor() {
		this.fg = new FormGroup({
			"textInput": new FormControl(undefined, StandardizedValidators.textWithLengthsOf(0, 100, false)),
			"status": new FormControl(eQuestionStatus["Todas"], StandardizedValidators.selectField_notRequired)
		});

		this.fcStatus.valueChanges.subscribe(()=> {
			this.emit();
		})
		this.fcTextInput.valueChanges.subscribe(()=> {
			clearTimeout(this.emitTimeoutRef);
			this.emitTimeoutRef = setTimeout(() => {
				this.emit();
			}, 230);
		});
	}

	private get fcTextInput() { return this.fg.get("textInput")!; }
	private get fcStatus() { return this.fg.get("status")!; }

	private emit() {
		if (this.fg.valid) {
			this.eeFiltersChange.emit(new QuestionFilterFields(this.fcTextInput.value, this.fcStatus.value));
		}
	}
}
